import { ComponentGroup } from '../types.js'

const bothArrow = new URL('../../../icons/components/both-arrow.png', import.meta.url).href
const dash = new URL('../../../icons/components/dash.png', import.meta.url).href
const lineIcon = new URL('../../../icons/components/line.png', import.meta.url).href
const polyline = new URL('../../../icons/components/polyline.png', import.meta.url).href
const singleArrow = new URL('../../../icons/components/single-arrow.png', import.meta.url).href
const ortholine = new URL('../../../icons/components/ortholine.png', import.meta.url).href

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
	  .st3{fill:none;stroke:{{strokeColor}};stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
	  .st4{fill:none;stroke:{{strokeColor}};stroke-width:1.5;stroke-miterlimit:10;stroke-dasharray:3,1.5;}
  </style>
  <g>
	  <line class="st3" x1="1.7" y1="18.9" x2="26.3" y2="6.2"/>
	  <line class="st4" x1="1.7" y1="23.8" x2="28.3" y2="10.1"/>
  </g>
</svg>
`

export const line: ComponentGroup = {
  name: 'line',
  description: 'a group of various lines',
  icon,
  templates: [
    {
      type: 'line',
      description: 'simple line',
      icon: lineIcon,
      group: 'line',
      model: {
        type: 'line',
        x1: 100,
        y1: 100,
        x2: 200,
        y2: 200,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 3,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'dash',
      description: 'dash line',
      icon: dash,
      group: 'line',
      model: {
        type: 'line',
        x1: 100,
        y1: 100,
        x2: 200,
        y2: 200,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 3,
        lineDash: 'round-dot',
        lineCap: 'butt'
      }
    },
    {
      type: 'single arrow',
      description: 'single arrow tip line',
      icon: singleArrow,
      group: 'line',
      model: {
        type: 'line',
        x1: 100,
        y1: 100,
        x2: 200,
        y2: 200,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 3,
        hidden: false,
        lineWidth: 3,
        lineDash: 'solid',
        begin: 'arrow',
        lineCap: 'butt'
      }
    },
    {
      type: 'both arrow',
      description: 'both arrow tip line',
      icon: bothArrow,
      group: 'line',
      model: {
        type: 'line',
        x1: 100,
        y1: 100,
        x2: 200,
        y2: 200,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 3,
        lineDash: 'solid',
        begin: 'arrow',
        end: 'arrow',
        lineCap: 'butt'
      }
    },
    {
      type: 'polyline',
      description: 'polyline',
      icon: polyline,
      group: 'line',
      model: {
        type: 'polyline',
        path: [
          { x: 100, y: 100 },
          { x: 200, y: 100 },
          { x: 200, y: 200 },
          { x: 100, y: 200 }
        ],
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt',
        round: 10
      }
    }
  ]
}
